import { render } from "./training.vue?vue&type=template&id=d0611008&scoped=true"
import script from "./training.vue?vue&type=script&lang=js"
export * from "./training.vue?vue&type=script&lang=js"

import "./training.vue?vue&type=style&index=0&id=d0611008&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0611008"]])

export default __exports__